import { AxiosError } from "axios";
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ITicketsAuto } from "../../../../../../interfaces";
import TicketsAutoService from "../../../../../../services/http/services/TicketsAutoService";
import { EmitError } from "../../../../../../utils/EmitError";

export default function useTickets() {

    const [ticketsAuto, setTicketsAuto] = useState<Array<ITicketsAuto>>([]);
    const [page, setPage] = useState<number>(1);
    const [hasMore, setHasMore] = useState(true);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isLoadingTickets, setIsLoadingTickets] = useState<boolean>(false);

    const { id } = useParams();

    const navigate = useNavigate();

    const loadMore = useCallback(async () => {
        if (isLoadingTickets) {
            return;
        }

        const controller = new AbortController();

        try {
            setIsLoadingTickets(true);

            const ticketsData = await TicketsAutoService.listTicketsByGiveawayId(Number(id), page, controller.signal);

            if (ticketsData.records.length === 0) {
                setHasMore(false);
            }

            setTicketsAuto((prevState) => [...prevState, ...ticketsData.records]);
            setPage((prevState) => prevState + 1);
            setIsLoadingTickets(false);

        } catch (err) {
            if (err instanceof AxiosError && err.name === "CanceledError") {
                return;
            }

            setIsLoadingTickets(false);
            EmitError(err);
        }

        return () => {
            controller.abort();
        }
    }, [id, page, isLoadingTickets]);

    useEffect(() => {
        if (!id) {
            return;
        }

        const controller = new AbortController();

        async function loadData() {
            try {
                setIsLoading(true);

                const ticketsData = await TicketsAutoService.listTicketsByGiveawayId(Number(id), 1, controller.signal);

                setTicketsAuto(ticketsData.records);
                if (ticketsData.records.length < 100) {
                    setHasMore(false);
                }
                setPage((prevState) => prevState + 1);
                setIsLoading(false);
            } catch (err) {
                if (err instanceof AxiosError && err.name === 'CanceledError') {
                    return;
                }

                EmitError(err, true, 'giveawayTickets_asodkaskldasd');
                setIsLoading(false);
            }
        }

        loadData();

        return () => {
            controller.abort();
        }
    }, [id, navigate]);

    return {
        isLoading,
        ticketsAuto,
        loadMore,
        hasMore
    }
}
